import Autocomplete from "@tomickigrzegorz/autocomplete";
import geocoder from "../geocoder";
import { defaults } from "../autocomplete";

export default ({ old = {} }) => ({
  selected: old,
  autocomplete: null,
  abortController: null,

  init() {
    const geocode = geocoder(true);

    this.$refs.input.value = this.selected.place_name || "";

    this.autocomplete = new Autocomplete(this.$refs.input.id, {
      ...defaults,
      onSearch: async ({ currentValue }) => {
        this.abortController?.abort();
        this.abortController = new AbortController();

        try {
          const locations = await geocode(
            currentValue,
            {
              includeAddresses: true,
              includeStates: false,
            },
            this.abortController.signal,
          );

          this.abortController = null;
          return locations;
        } catch (error) {
          this.abortController = null;

          if (error.name === "AbortError") {
            return [];
          }

          console.error(error);
          return [];
        }
      },

      onSubmit: async ({ object }) => {
        this.selected = object;
      },
    });
  },

  destroy() {
    this.autocomplete?.destroy();
    this.abortController?.abort();
  },
});
